export default __webpack_public_path__ + "static/media/visa.830dc75e.svg";